module.exports = __webpack_public_path__ + "static/media/天賦基因套餐_QandA.f73ae5f.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/天賦基因套餐_QandA.mp4
// module id = Vint
// module chunks = 0